import { useEffect, useState } from 'react';

export function useCatalog(fetchFn, { mapItem } = {}) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    async function load() {
      setIsLoading(true);
      setError(null);
      try {
        const data = await fetchFn({ signal: controller.signal });
        const list = Array.isArray(data) ? data : [];
        setItems(mapItem ? list.map(mapItem) : list);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err);
          setItems([]);
        }
      } finally {
        setIsLoading(false);
      }
    }

    load();
    return () => controller.abort();
  }, [fetchFn, mapItem]);

  return { items, isLoading, error };
}